import {
  faExclamationTriangle,
  faStarCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '../Tooltip';

interface EmailConfidenceChipProps {
  variant?: 'regular' | 'small';
  source: string;
}

const EmailConfidenceChip = ({
  variant = 'regular',
  source,
}: EmailConfidenceChipProps) => {
  const sourceConfigs = {
    enriched: {
      label: 'Enriched',
      icon: faStarCircle,
      textColor: 'text-indigo-600',
      bgColor: 'bg-indigo-50',
      borderColor: 'border-indigo-600',
      text: 'This email comes from a trusted third‑party data partner and has been validated. Confidence is high.',
    },
    default: {
      label: 'Best Guess',
      icon: faExclamationTriangle,
      textColor: 'text-amber-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-600',
      text: "This email was generated by an algorithm using publicly available patterns. Confidence is moderate — accuracy isn't guaranteed, and the recipient inbox may reject unknown senders.",
    },
  };

  const isEnriched = source === 'enriched';
  const config = sourceConfigs[isEnriched ? 'enriched' : 'default'];

  const sourceText = config.label;
  const sourceIcon = config.icon;
  const sourceColor = config.textColor;
  const backgroundColor = config.bgColor;
  const borderColor = config.borderColor;

  const TooltipContent = (
    <div className="flex flex-col gap-2 w-44 p-4">
      <div className="flex items-center gap-2">
        <Icon icon={sourceIcon} size="lg" className={`${sourceColor}`} />
        <p className="text-primary text-sm font-medium">{sourceText}</p>
      </div>
      <p className="text-xs text-secondary">{config.text}</p>
    </div>
  );

  return (
    <Tooltip
      content={TooltipContent}
      slotProps={{
        containerClassName: '!bg-white border border-neutral-300',
      }}
    >
      {variant === 'regular' ? (
        <div
          className={`px-2 py-1 ${backgroundColor} rounded-full border ${borderColor} inline-flex justify-center items-center gap-1`}
        >
          <div className={`${sourceColor} text-xs`}>
            <Icon icon={sourceIcon} className={`${sourceColor} pr-1`} />
            {sourceText}
          </div>
        </div>
      ) : (
        <div>
          <Icon icon={sourceIcon} className={`${sourceColor} pr-1`} />
        </div>
      )}
    </Tooltip>
  );
};

export default EmailConfidenceChip;
